import React from 'react';
import { Container, Title, Text, Card, Group, Button } from '@mantine/core';

const Personal = () => (
  <div style={{
    background: 'linear-gradient(180deg, var(--cream) 0%, var(--linen) 100%)',
    minHeight: '80vh',
    padding: '3rem 0'
  }}>
    <Container size="md" py="xl">
      <Title
        order={1}
        ta="center"
        mb="xl"
        className="gradient-text"
        style={{ fontSize: '2.5rem', fontWeight: 700 }}
      >
        Guru Dharam Singh's Site
      </Title>
      <Card
        shadow="lg"
        padding="xl"
        radius="lg"
        className="card-natural"
        style={{ maxWidth: '800px', margin: '0 auto' }}
      >
        <Text size="lg" mb="md" fw={500} c="var(--charcoal)">Welcome to my personal page!</Text>
        <Text mb="md" size="md" c="var(--charcoal)" style={{ lineHeight: 1.8 }}>
          I am dedicated to sharing the transformative power of Kundalini Yoga and meditation.
          Through early morning practice and community gathering, we explore the depths of
          consciousness and spiritual awakening.
        </Text>
        <Text mb="md" size="md" c="var(--charcoal)" style={{ lineHeight: 1.8 }}>
          Join me for yoga classes that combine traditional Kundalini techniques with
          modern understanding, creating a bridge between ancient wisdom and contemporary life.
        </Text>
        <Group justify="center" mt="xl">
          <Button
            size="lg"
            style={{
              background: 'var(--saffron-bright)',
              color: 'white',
              borderRadius: '12px',
              padding: '12px 24px',
              fontWeight: 600,
              boxShadow: '0 4px 16px rgba(244, 196, 48, 0.4)',
              border: 'none'
            }}
          >
            Book a Class
          </Button>
        </Group>
      </Card>
    </Container>
  </div>
);

export default Personal;
